import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {AdvertComponent} from './advert.component';
import {AdvertService} from './advert.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [],
  declarations: [AdvertComponent],
  exports: [AdvertComponent]
})
export class AdvertModule {
}
